var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "secContainer" }, [
      _c(
        "div",
        { staticClass: "task-base" },
        [
          _c(
            "van-row",
            {
              staticClass: "p-t-15",
              attrs: { align: "center", justify: "center" },
            },
            [
              _c(
                "van-col",
                { attrs: { span: "3" } },
                [
                  _c("van-icon", {
                    attrs: { name: "revoke", size: "30", color: "#FFDA3E" },
                    on: { click: _vm.rtList },
                  }),
                ],
                1
              ),
              _c("van-col", { attrs: { span: "19" } }, [
                _c("div", [
                  _c("span", { staticClass: "task-title" }, [
                    _vm._v(_vm._s(_vm.taskForm.taskName)),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm.taskForm.createName && _vm.taskForm.createTime
            ? _c(
                "van-row",
                {
                  staticClass: "p-t-15",
                  attrs: { type: "flex", align: "center", justify: "center" },
                },
                [
                  _c("van-col", { attrs: { span: "18" } }, [
                    _c("div", [
                      _c("span", { staticClass: "row-name" }, [
                        _vm._v(
                          _vm._s(_vm.taskForm.createName) +
                            "创建于" +
                            _vm._s(_vm.taskForm.createTime)
                        ),
                      ]),
                    ]),
                  ]),
                  _c("van-col", { attrs: { span: "4" } }, [
                    _c(
                      "div",
                      [
                        _vm.taskForm.status == 0
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state wks",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("未开始 ")]
                            )
                          : _vm._e(),
                        _vm.taskForm.status == 2
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state ywc",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("已完成 ")]
                            )
                          : _vm._e(),
                        _vm.taskForm.status == 1
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state jxz",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("进行中 ")]
                            )
                          : _vm._e(),
                        _vm.taskForm.status == 3
                          ? _c(
                              "van-tag",
                              {
                                staticClass: "task-state yzz",
                                attrs: {
                                  size: "small",
                                  mark: "",
                                  type: "primary",
                                },
                              },
                              [_vm._v("已中止 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "van-row",
            {
              staticClass: "row-info",
              attrs: { type: "flex", justify: "space-around" },
            },
            [
              _c("van-col", { attrs: { span: "4" } }, [
                _c("div", { staticClass: "row-name" }, [_vm._v("关联项目")]),
              ]),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("div", { staticClass: "row-value" }, [
                  _vm._v(_vm._s(_vm.taskForm.projectName)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            {
              staticClass: "row-info",
              attrs: { type: "flex", justify: "space-around" },
            },
            [
              _c("van-col", { attrs: { span: "4" } }, [
                _c("div", { staticClass: "row-name" }, [_vm._v("执行人")]),
              ]),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("div", { staticClass: "row-value" }, [
                  _vm._v(_vm._s(_vm.taskForm.executorName)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            {
              staticClass: "row-info",
              attrs: { type: "flex", justify: "space-around" },
            },
            [
              _c("van-col", { attrs: { span: "4" } }, [
                _c("div", { staticClass: "row-name" }, [_vm._v("任务进度")]),
              ]),
              _c(
                "van-col",
                { attrs: { span: "16" } },
                [
                  _c("van-progress", {
                    attrs: {
                      color: "#FFDA3E",
                      percentage: _vm.taskForm.progress
                        ? _vm.taskForm.progress
                        : 0,
                      "stroke-width": "8",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("van-divider"),
          _c(
            "van-row",
            {
              staticClass: "row-info",
              attrs: { type: "flex", justify: "space-around" },
            },
            [
              _c("van-col", { attrs: { span: "4" } }, [
                _c("div", { staticClass: "row-name" }, [
                  _vm._v("计划起止时间"),
                ]),
              ]),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("div", { staticClass: "row-value" }, [
                  _vm._v(
                    _vm._s(_vm.taskForm.planStartTime) +
                      _vm._s(
                        _vm.taskForm.planEndTime == null
                          ? ""
                          : "至" + _vm.taskForm.planEndTime
                      ) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            {
              staticClass: "row-info",
              attrs: { type: "flex", justify: "space-around" },
            },
            [
              _c("van-col", { attrs: { span: "4" } }, [
                _c("div", { staticClass: "row-name" }, [
                  _vm._v("实际执行时间"),
                ]),
              ]),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("div", { staticClass: "row-value" }, [
                  _vm._v(
                    _vm._s(_vm.taskForm.startTime) +
                      _vm._s(
                        _vm.taskForm.endTime == null
                          ? ""
                          : "至" + _vm.taskForm.endTime
                      ) +
                      " "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            {
              staticClass: "row-info",
              attrs: { type: "flex", justify: "space-around" },
            },
            [
              _c("van-col", { attrs: { span: "4" } }, [
                _c("div", { staticClass: "row-name" }, [_vm._v("上级任务")]),
              ]),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("div", { staticClass: "row-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.taskForm.parentName == null
                        ? "无"
                        : _vm.taskForm.parentName
                    )
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "van-row",
            {
              staticClass: "row-info",
              attrs: { type: "flex", justify: "space-around" },
            },
            [
              _c("van-col", { attrs: { span: "4" } }, [
                _c("div", { staticClass: "row-name" }, [_vm._v("前置任务")]),
              ]),
              _c("van-col", { attrs: { span: "16" } }, [
                _c("div", { staticClass: "row-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.taskForm.predependence == null
                        ? "无"
                        : _vm.taskForm.predependence
                    )
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm.feedbackList.length != 0
        ? _c("div", { staticClass: "interval-word" }, [
            _c("span", [_vm._v("历史反馈记录")]),
          ])
        : _vm._e(),
      _vm.feedbackList.length != 0
        ? _c(
            "div",
            { staticClass: "task-base" },
            [
              _c(
                "van-tabs",
                {
                  attrs: { sticky: "", color: "#FFDA3E" },
                  on: { click: _vm.feedbackTabClick },
                  model: {
                    value: _vm.feedbackTab,
                    callback: function ($$v) {
                      _vm.feedbackTab = $$v
                    },
                    expression: "feedbackTab",
                  },
                },
                [
                  _c("van-tab", { attrs: { name: 0, title: "我的反馈" } }),
                  _c("van-tab", { attrs: { name: 1, title: "全部反馈" } }),
                ],
                1
              ),
              _vm._l(_vm.feedbackList, function (item) {
                return _c(
                  "van-row",
                  {
                    key: item.id,
                    staticClass: "p-b-20",
                    attrs: { align: "center" },
                  },
                  [
                    _c(
                      "van-col",
                      { attrs: { span: "24" } },
                      [
                        _c(
                          "van-row",
                          {
                            staticClass: "feedback-title-row",
                            attrs: {
                              type: "flex",
                              align: "center",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: "6" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-name" }, [
                                  _vm._v("是否补录"),
                                ]),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "16" } }, [
                              _c(
                                "div",
                                [
                                  item.blFlag == "Y"
                                    ? _c(
                                        "van-tag",
                                        {
                                          attrs: {
                                            size: "medium",
                                            plain: "",
                                            type: "primary",
                                          },
                                        },
                                        [_vm._v("是")]
                                      )
                                    : _vm._e(),
                                  item.blFlag == "N"
                                    ? _c(
                                        "van-tag",
                                        {
                                          attrs: {
                                            size: "medium",
                                            plain: "",
                                            type: "danger",
                                          },
                                        },
                                        [_vm._v("否")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            attrs: {
                              type: "flex",
                              align: "center",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: "6" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-name" }, [
                                  _vm._v("反馈人"),
                                ]),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "16" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-value" }, [
                                  _vm._v(_vm._s(item.executorName)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            attrs: {
                              type: "flex",
                              align: "center",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: "6" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-name" }, [
                                  _vm._v("反馈工时"),
                                ]),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "16" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-value" }, [
                                  _vm._v(_vm._s(item.hour) + "小时"),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            attrs: {
                              type: "flex",
                              align: "center",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: "6" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-name" }, [
                                  _vm._v("反馈时间"),
                                ]),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "16" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-value" }, [
                                  _vm._v(_vm._s(item.createTime)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            attrs: {
                              type: "flex",
                              align: "center",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: "6" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-name" }, [
                                  _vm._v("进度"),
                                ]),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "16" } }, [
                              _c(
                                "div",
                                [
                                  _c("van-progress", {
                                    attrs: {
                                      color: "#FFDA3E",
                                      percentage: item.progress
                                        ? item.progress
                                        : 0,
                                      "stroke-width": "8",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            attrs: {
                              type: "flex",
                              align: "center",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: "6" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-name" }, [
                                  _vm._v("完成情况"),
                                ]),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "16" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-value-small" }, [
                                  _vm._v(_vm._s(item.message)),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            attrs: {
                              type: "flex",
                              align: "col-top",
                              justify: "center",
                            },
                          },
                          [
                            _c("van-col", { attrs: { span: "6" } }, [
                              _c("div", [
                                _c("span", { staticClass: "row-name" }, [
                                  _vm._v("反馈附件"),
                                ]),
                              ]),
                            ]),
                            _c(
                              "van-col",
                              { staticClass: "p-0", attrs: { span: "16" } },
                              [
                                _c("van-field", {
                                  staticClass:
                                    "noAfterBorder p-l-0 p-r-0 fileValueBox",
                                  attrs: { "input-align": "right", name: "fj" },
                                  domProps: { value: item.fileList },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "input",
                                        fn: function () {
                                          return [
                                            _c("uploadFiles", {
                                              attrs: {
                                                moduleType: "taskFeedback",
                                                disabled: true,
                                                uploaderBtnShow: false,
                                                files: item.fileList,
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.commentList.length != 0
        ? _c("div", { staticClass: "interval-word" }, [
            _c("span", [_vm._v("员工评论")]),
          ])
        : _vm._e(),
      _vm.commentList.length != 0
        ? _c(
            "div",
            { staticClass: "task-base" },
            [
              _c(
                "van-row",
                _vm._l(_vm.commentList, function (item, index) {
                  return _c(
                    "van-col",
                    { key: index, attrs: { span: "24" } },
                    [
                      _c(
                        "van-row",
                        {
                          staticClass: "text-center",
                          attrs: {
                            justify: "center",
                            type: "flex",
                            align: "center",
                          },
                        },
                        [
                          _c(
                            "van-col",
                            { attrs: { span: "4" } },
                            [
                              _c("van-icon", {
                                staticClass: "m-t-10",
                                attrs: {
                                  name: "https://b.yzcdn.cn/vant/icon-demo-1126.png",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "van-col",
                            { attrs: { span: "20" } },
                            [
                              _c(
                                "van-row",
                                { staticClass: "text-center" },
                                [
                                  _c("van-col", { attrs: { span: "4" } }, [
                                    _c("span", { staticClass: "row-value" }, [
                                      _vm._v(_vm._s(item.createName)),
                                    ]),
                                  ]),
                                  _c("van-col", { attrs: { span: "8" } }),
                                  _c("van-col", { attrs: { span: "12" } }, [
                                    _c("span", { staticClass: "row-name" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.parseTime(
                                            item.createTime,
                                            "{y}-{m}-{d} {h}:{i}"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                { staticClass: "text-left m-l-10" },
                                [
                                  _c("van-col", { attrs: { span: "20" } }, [
                                    _c(
                                      "span",
                                      { staticClass: "row-name-small" },
                                      [_vm._v(_vm._s(item.message))]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("van-divider", { staticClass: "divider-small" }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "h-170" }),
      _c(
        "div",
        { staticClass: "comment-input" },
        [
          _c(
            "van-cell-group",
            { staticClass: "flex row-center col-center" },
            [
              _c(
                "div",
                {
                  staticClass: "font-32 p-l-20",
                  on: {
                    click: function ($event) {
                      _vm.deptUserTreeAll.show = true
                    },
                  },
                },
                [_vm._v("@")]
              ),
              _c(
                "van-popup",
                {
                  attrs: { "get-container": "body", position: "bottom" },
                  model: {
                    value: _vm.deptUserTreeAll.show,
                    callback: function ($$v) {
                      _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                    },
                    expression: "deptUserTreeAll.show",
                  },
                },
                [
                  _c("van-nav-bar", {
                    attrs: {
                      "left-text": "取消",
                      "right-text": "确定",
                      title: "选择人员",
                    },
                    on: {
                      "click-left": function ($event) {
                        _vm.deptUserTreeAll.show = false
                      },
                      "click-right": _vm.commentPopupSubmit,
                    },
                  }),
                  _c("van-search", {
                    attrs: { clearable: "", shape: "round" },
                    on: {
                      input: function ($event) {
                        return _vm.treeSearch($event, _vm.$refs.tree)
                      },
                    },
                    model: {
                      value: _vm.deptUserTreeAll.filterText,
                      callback: function ($$v) {
                        _vm.$set(_vm.deptUserTreeAll, "filterText", $$v)
                      },
                      expression: "deptUserTreeAll.filterText",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "h-vh-50",
                      staticStyle: { "overflow-y": "auto" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "p-10" },
                        [
                          _c("el-tree", {
                            ref: "tree",
                            attrs: {
                              data: _vm.deptUserTreeAll.data,
                              "filter-node-method": _vm.filterNode,
                              "check-on-click-node": "",
                              "check-strictly": "",
                              "node-key": "uuid",
                              "show-checkbox": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("van-field", {
                staticClass: "p-l-26 p-r-20 p-t-20 p-b-20 messageBox",
                attrs: {
                  border: true,
                  center: "",
                  clearable: "",
                  type: "textarea",
                  autosize: "",
                  placeholder: "请输入评论内容",
                },
                scopedSlots: _vm._u([
                  {
                    key: "button",
                    fn: function () {
                      return [
                        _c(
                          "van-button",
                          {
                            attrs: {
                              size: "small",
                              icon: "comment-o",
                              round: "",
                              type: "primary",
                            },
                            on: { click: _vm.sendComment },
                          },
                          [_vm._v("发送 ")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.commentForm.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.commentForm, "message", $$v)
                  },
                  expression: "commentForm.message",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }